/**
 * Validate email
 */
import queryString from "query-string"
// import type { Slot } from "../../model/MyDevelopmentContainer.model";

const validateEmail = (email) => {
  let reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
  return reg.test(email)
}

/**
 * Validate specific phone
 */
const validatePhone = (phone) => {
  let reg = /^(([+]{0,1}\d{2})|\d?)[\s-]?[0-9]{2}[\s-]?[0-9]{3}[\s-]?[0-9]{4}$/
  return reg.test(phone)
}

/**
 * Generate user name
 */
export const generateTwoNumber = (min, max) => {
  return Math.floor(min + Math.random() * (max + 1 - min))
}

export const removeAccents = (str) => {
  return str
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[đĐ]/g, "d")
    .replace(/-/g, "")
    .replace(/([^0-9a-z-A-Z\s])/g, "")
}

export const containSpecialChar = (str) => {
  return str.match(/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/) ? true : false
}

/**
 * Generate class code
 */
const generateClassCode = (length) => {
  const lowercase = "abcdefghijklmnopqrstuvwxyz"
  const uppercase = lowercase.toUpperCase()
  const numbers = "0123456789"
  const [lower, upper, num] = [
    Math.ceil(length / 3),
    Math.ceil(length / 3),
    length - 2 * Math.ceil(length / 3),
  ]
  const shuffle = (array) => {
    return array.sort(() => Math.random() - 0.5)
  }
  const getCharacters = (length, string) => {
    let characters = []
    for (let i = 0; i < length; i++) {
      let random = Math.floor(Math.random() * string.length)
      characters[i] = string.charAt(random)
    }
    return characters
  }
  const passwordCharacters = shuffle([
    ...getCharacters(lower, lowercase),
    ...getCharacters(upper, uppercase),
    ...getCharacters(num, numbers),
  ])
  return passwordCharacters.join("")
}

const getSourceTypeFromUrl = (url) => {
  return validateYouTubeUrl(url) ? "youtube" : "s3"
}

function validateYouTubeUrl(url) {
  return url.includes("youtube.com") || url.includes("youtu.be") ? true : false
}

function checkVideoAvailability(videoUrl) {
  return new Promise((resolve, reject) => {
    const videoElement = document.createElement("video")
    videoElement.src = videoUrl

    videoElement.addEventListener("loadedmetadata", () => {
      resolve(videoElement.duration)
    })

    videoElement.addEventListener("error", (e) => {
      resolve(false)
    })
  })
}

const isShortLinkYoutube = (url) => {
  return url.includes("youtube") && url.includes("short") ? true : false
}
const parseObjectToString = (search) => {
  return queryString.stringify(search)
}

const createHTML = (html) => {
  return html ? (
    <div dangerouslySetInnerHTML={{ __html: html.replace(/\n/g, "<br>") }} />
  ) : (
    ""
  )
}

export const objectToQueryString = (params) => {
  const queryParts = []

  for (const [key, value] of Object.entries(params)) {
    // Never serialize null/undefined values: doing so produces query strings
    // like `teacherId=undefined`, which the backend rejects (e.g. CLIENT_EX002
    // "For input string: undefined"). Empty strings are kept intentionally,
    // since some endpoints rely on them (e.g. page/sort defaults).
    if (value === null || value === undefined) continue
    queryParts.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
  }

  return queryParts.join("&")
}

const joinArrayClassname = (arrayClassname = []) => {
  return arrayClassname.join(" ")
}

export const canParseStringToObject = (inputString = "") => {
  if (typeof inputString !== "string") return false
  try {
    const result = JSON.parse(inputString)
    return result
  } catch (error) {
    console.error("Failed to parse JSON:", error)
    // Xử lý thêm hoặc trả về giá trị mặc định tùy theo nghiệp vụ
    return null // Ví dụ, trả về null hoặc {}
  }
}

export const sleep = (ms) => {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

const PASSWORD_VALIDATION_RULES = {
  MIN_LENGTH: 8,
  UPPERCASE_REGEX: /[A-Z]/,
  LOWERCASE_REGEX: /[a-z]/,
  NUMBER_REGEX: /[0-9]/,
  SPECIAL_CHAR_REGEX: /[@$!%*?&]/,
  NO_SPACES_REGEX: /^\S*$/,
}
export const validatePasswordStrength = (password) => {
  const rules = PASSWORD_VALIDATION_RULES

  if (password.length < rules.MIN_LENGTH) {
    return {
      isValid: false,
      errorMessage: `Password must be at least ${rules.MIN_LENGTH} characters`,
    }
  }

  if (!rules.UPPERCASE_REGEX.test(password)) {
    return {
      isValid: false,
      errorMessage: "Password must contain at least one uppercase letter",
    }
  }

  if (!rules.LOWERCASE_REGEX.test(password)) {
    return {
      isValid: false,
      errorMessage: "Password must contain at least one lowercase letter",
    }
  }

  if (!rules.NUMBER_REGEX.test(password)) {
    return {
      isValid: false,
      errorMessage: "Password must contain at least one number",
    }
  }

  if (!rules.SPECIAL_CHAR_REGEX.test(password)) {
    return {
      isValid: false,
      errorMessage:
        "Password must contain at least one special character (@$!%*?&)",
    }
  }

  if (!rules.NO_SPACES_REGEX.test(password)) {
    return {
      isValid: false,
      errorMessage: "Password must not contain any spaces",
    }
  }

  return { isValid: true, errorMessage: null }
}

export const compareArraysByValue = (array1, array2) => {
  const sortedArray1 = array1.map((item) => item.value).sort()
  const sortedArray2 = array2.map((item) => item.value).sort()
  return JSON.stringify(sortedArray1) === JSON.stringify(sortedArray2)
}

export const renderBackgroundColorLXO = (type) => {
  switch (type) {
    case "inProgress":
      return "linear-gradient(122deg, #1171EF 9.06%, #11CDEF 88.15%)"
    case "completedOverdue":
      return "linear-gradient(122deg, #F5365C 9.06%, #F07680 88.15%)"
    case "overdue":
      return "linear-gradient(275deg, #F80 19.26%, #F54A45 94.91%)"
    case "PLANNING":
      return "linear-gradient(122deg, #DF25FD 9.06%, #D483E2 88.15%)"
    default:
      return "linear-gradient(122deg, #DF25FD 9.06%, #D483E2 88.15%)"
  }
}

export const renderBackgroundColorLXO2 = (status) => {
  switch (status) {
    case "To-do":
      return "linear-gradient(122deg, #1171EF 9.06%, #11CDEF 88.15%)"
    case "Completed":
      return "linear-gradient(122deg, #43E97B 9.06%, #059279 88.15%)"
    case "Overdue":
      return "linear-gradient(275deg, #FF8800 19.26%, #F54A45 94.91%)"
    case "CompletedOverdue":
      return "linear-gradient(122deg, #F5365C 9.06%, #F07680 88.15%)"
    default:
      return "linear-gradient(122deg, #DF25FD 9.06%, #D483E2 88.15%)"
  }
}

export const pickUploadFiles = (selectedFiles = []) => {
  const filesToUpload = (selectedFiles ?? []).filter((a) => a instanceof File)

  return filesToUpload
}

export const mapUploadedToDtoAttachments = (uploaded = {}) => {
  const dataUpload = uploaded?.data?.data
  return dataUpload
    ? dataUpload.map((u) => ({
        fileName: u.fileName,
        contentType: u.contentType,
        sizeBytes: u.sizeBytes,
        url: u.url,
        storagePath: u.storagePath,
      }))
    : []
}

export const mapExistingUrlToDtoAttachments = (selectedFiles = []) => {
  // nếu file đã có url sẵn (vd đã upload trước đó) thì giữ lại
  return selectedFiles
    .filter((x) => x && x.url && !(x.file instanceof File))
    .map((x) => ({
      attachmentId: x.attachmentId ?? 0,
      fileName: x.fileName,
      contentType: x.contentType,
      sizeBytes: x.sizeBytes,
      url: x.url,
    }))
}

export const Helpers = {
  validateEmail,
  validatePhone,
  generateTwoNumber,
  removeAccents,
  containSpecialChar,
  generateClassCode,
  getSourceTypeFromUrl,
  validateYouTubeUrl,
  checkVideoAvailability,
  parseObjectToString,
  isShortLinkYoutube,
  createHTML,
  objectToQueryString,
  joinArrayClassname,
  canParseStringToObject,
  sleep,
  validatePasswordStrength,
  compareArraysByValue,
}
